const buildAgencyJobberDetailsUrl = (jobberEmail: string): string => {
    return `/agency/workforce-jobber?jobberEmail=${encodeURIComponent(jobberEmail)}`;
};

const parseJobberEmailFromQueryString = (queryString: string): string | null => {
    const normalizedQuery: string = queryString.startsWith('?') ? queryString.substring(1) : queryString;
    const params: Record<string, string> = {};
    normalizedQuery.split('&').forEach((param: string) => {
        const [key, ...valueParts] = param.split('=');
        if (key) {
            const value: string = valueParts.join('=');
            const encodedValue: string = value.replace(/\+/g, '%2B');
            params[key] = decodeURIComponent(encodedValue);
        }
    });
    const jobberEmail: string | undefined = params['jobberEmail'];
    if (!jobberEmail || jobberEmail.trim() === '') {
        return null;
    }
    return jobberEmail;
};

export {
    buildAgencyJobberDetailsUrl,
    parseJobberEmailFromQueryString,
};
